// Execute `action` `executionsPerPeriod` times during `period` milliseconds.
// If the sum of the returned values is bigger than `maxSumPerPeriod` the execution frequency is reduced.
export class Throttle {
  private readonly values: number[];
  private index = 0;
  private total = 0;
  private wait = 0;

  constructor(
    private period: number,
    private executionsPerPeriod: number,
    private maxSumPerPeriod: number,
    private action: () => number,
  ) {
    this.values = new Array<number>(executionsPerPeriod);
    this.run();
  }

  run() {
    this.total -= this.values[this.index] || 0;
    const rate = this.total / this.maxSumPerPeriod;
    let value = 0;
    // hard throttling when we're over maxSumPerPeriod
    if (rate > 1 || this.wait > 0) {
      this.wait--;
    } else {
      value = this.action();
      // start throttling when half of maxSumPerPeriod is reached
      this.wait = Math.floor(8 * rate * rate * rate);
    }
    this.total += this.values[this.index] = value;
    this.index = (this.index + 1) % this.executionsPerPeriod;
    setTimeout(() => this.run(), this.period / this.executionsPerPeriod);
  }
}
